module.exports = __webpack_public_path__ + "static/media/ProfilePic.821e687d.jpg";